import React from 'react';
import dayjs from 'dayjs';
import { ICardContextProvider } from 'context/cardContext';
import Card from 'components/Card';

export const MODES = {
  MISSED: 'MISSED',
  REVEAL_NOW: 'REVEAL_NOW',
  REVEAL_ON: 'REVEAL_ON',
  REVEALED_GAME_STARTED: 'REVEALED_GAME_STARTED',
  REVEALED_GAME_NOT_STARTED: 'REVEALED_GAME_NOT_STARTED',
  REVEALED_GAME_FULL_TIME: 'REVEALED_GAME_FULL_TIME',
  PLACEHOLDER: 'PLACEHOLDER',
  REVEALED_WITH_BONUS: 'REVEALED_WITH_BONUS'
};

export interface IStubbedData {
  now: any;
  eventStartTime: number;
  revealTime: number;
  expiryTime: number;
  revealed: boolean;
  points: number;
  teamCode: string;
  teamName: string;
  shirtNumber: string;
  lastName: string;
  position: string;
  participantCodeOne: string;
  participantCodeTwo: string;
  eventActive: boolean;
  eventHomeScore: number;
  eventAwayScore: number;
  eventPeriod: string;
  eventClockTime: string;
  decisionTimeBonus: boolean;
  newSigningBonus: boolean;
}

interface ICardStubbedDataWrapperProps {
  mode: string;
  index: number;
}

const CardStubbedDataWrapper = (props: ICardStubbedDataWrapperProps) => {
  let stubbedDataPlayerData: IStubbedData = {
    now: dayjs(),
    eventStartTime: 0,
    revealTime: 0,
    expiryTime: 0,
    teamCode: 'NEW',
    teamName: 'Newcastle United',
    shirtNumber: '12',
    lastName: 'RAÚL',
    position: 'df',
    participantCodeOne: 'NEW',
    participantCodeTwo: 'ARS',
    points: 0,
    revealed: false,
    eventActive: true,
    eventHomeScore: 1,
    eventAwayScore: 2,
    eventPeriod: 'PM',
    eventClockTime: '0',
    decisionTimeBonus: false,
    newSigningBonus: false
  };

  const getPlayerData = () => {
    switch (props.mode) {
      case MODES.MISSED:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.revealTime = stubbedDataPlayerData.now.subtract(10, 'minute').valueOf();
        break;

      case MODES.REVEAL_NOW:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.revealTime = dayjs(stubbedDataPlayerData.eventStartTime).subtract(1, 'minute').valueOf();
        stubbedDataPlayerData.expiryTime = dayjs(stubbedDataPlayerData.revealTime).add(20, 'minute').valueOf();
        break;

      case MODES.REVEAL_ON:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.revealTime = stubbedDataPlayerData.now.add(10, 'minute').valueOf();
        stubbedDataPlayerData.expiryTime = dayjs(stubbedDataPlayerData.revealTime).add(20, 'minute').valueOf();
        break;

      case MODES.REVEALED_GAME_NOT_STARTED:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.add(10, 'second').valueOf();
        stubbedDataPlayerData.revealTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.expiryTime = dayjs(stubbedDataPlayerData.revealTime).add(20, 'minute').valueOf();
        stubbedDataPlayerData.revealed = true;
        break;

      case MODES.REVEALED_WITH_BONUS:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.add(10, 'second').valueOf();
        stubbedDataPlayerData.revealTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.expiryTime = dayjs(stubbedDataPlayerData.revealTime).add(20, 'minute').valueOf();
        stubbedDataPlayerData.revealed = true;
        stubbedDataPlayerData.decisionTimeBonus = true;
        stubbedDataPlayerData.newSigningBonus = true;
        break;

      case MODES.REVEALED_GAME_FULL_TIME:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.subtract(100, 'minute').valueOf();
        stubbedDataPlayerData.revealTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.expiryTime = dayjs(stubbedDataPlayerData.revealTime).add(20, 'minute').valueOf();
        stubbedDataPlayerData.revealed = true;
        stubbedDataPlayerData.eventPeriod = 'FT';
        stubbedDataPlayerData.eventClockTime = '90';
        break;

      case MODES.REVEALED_GAME_STARTED:
        stubbedDataPlayerData.eventStartTime = stubbedDataPlayerData.now.subtract(100, 'minute').valueOf();
        stubbedDataPlayerData.revealTime = stubbedDataPlayerData.now.valueOf();
        stubbedDataPlayerData.expiryTime = dayjs(stubbedDataPlayerData.revealTime).add(20, 'minute').valueOf();
        stubbedDataPlayerData.revealed = true;
        stubbedDataPlayerData.points = 3;
        stubbedDataPlayerData.eventActive = true;
        stubbedDataPlayerData.eventPeriod = 'HT';
        stubbedDataPlayerData.eventClockTime = '15';
        break;
    }

    return {
      eventId: 0,
      eventStartTime: stubbedDataPlayerData.eventStartTime,
      expiryTime: stubbedDataPlayerData.expiryTime,
      firstName: '',
      lastName: stubbedDataPlayerData.lastName,
      displayName: stubbedDataPlayerData.lastName,
      selnNumber: props.index || 0,
      points: stubbedDataPlayerData.points,
      position: stubbedDataPlayerData.position,
      returns: 0,
      revealTime: stubbedDataPlayerData.revealTime,
      shirtNumber: stubbedDataPlayerData.shirtNumber,
      revealed: stubbedDataPlayerData.revealed,
      teamCode: stubbedDataPlayerData.teamCode,
      teamMemberId: props.index || 0,
      teamName: stubbedDataPlayerData.teamName,
      eventParticipants: [
        {
          colourCode: '',
          participantCode: stubbedDataPlayerData.participantCodeOne,
          participantId: 0,
          participantName: '',
          position: 0,
          eventStartTime: stubbedDataPlayerData.eventStartTime
        },
        {
          colourCode: '',
          participantCode: stubbedDataPlayerData.participantCodeTwo,
          participantId: 0,
          participantName: '',
          position: 0,
          eventStartTime: stubbedDataPlayerData.eventStartTime
        }
      ]
    };
  };

  const data: ICardContextProvider = {
    player: getPlayerData(),
    receipt: 'fakeReceipt',
    gameId: 1,
    noEntry: true,
    stubbedMode: props.mode !== MODES.PLACEHOLDER,
    stubbedModeData: stubbedDataPlayerData,
    zIndex: props.index || 0,
    decisionTimeBonus: stubbedDataPlayerData.decisionTimeBonus,
    newSigningBonus: stubbedDataPlayerData.newSigningBonus
  };

  return <Card {...data} />;
};

export default CardStubbedDataWrapper;
